import React from "react";
import { useTransition, animated } from "react-spring";
import styles from "./AnimatedAlienImage.module.css";

const AnimatedAlienImage = ({ imageSrc, isPurple }) => {
  const imageTransition = useTransition([imageSrc], {
    keys: (item) => item,
    from: {
      opacity: isPurple ? 0 : 1,
      position: "absolute",
    },
    enter: {
      opacity: 1,
    },
    leave: {
      opacity: 0,
    },
    config: { duration: 1000 },
  });

  return (
    <div style={{ position: "relative" }}>
      {imageTransition((style, item) => (
        <animated.img
          style={style}
          src={item}
          className={styles.alienImage}
          alt="Animated"
          key={item}
        />
      ))}
    </div>
  );
};

export default AnimatedAlienImage;
